import { createTestIds } from '../../utils';
import { elements } from '../FormField/FormField.test-ids';

export const getFileInputTestIds = createTestIds('file-input', [
  'control',
  'files',
  ...elements
] as const);
